import React from 'react'
import PropTypes from 'prop-types'
import { CHARGING_POINT_SUPPORTED_PLUGS } from 'commons/js/constants'
import { Icon } from '@elparking/components'

class PlugIcon extends React.Component {
    static propTypes = {
        plugName: PropTypes.string,
        plugSlug: PropTypes.oneOf(CHARGING_POINT_SUPPORTED_PLUGS),
        size: PropTypes.string.isRequired,
        color: PropTypes.string,
    }

    getIconType (plugSlug) {
        if (CHARGING_POINT_SUPPORTED_PLUGS.some((supportedSlug) => supportedSlug === plugSlug)) {
            return plugSlug
        }
        return null
    }

    render () {
        const {plugName, plugSlug, size, color} = this.props
        const iconType = this.getIconType(plugSlug)

        return (
            iconType && <Icon type={iconType} title={plugName} size={size} color={color} />
        )
    }
}

export default PlugIcon
